export default {"src":"/_next/static/media/van.eb8d0927.svg","height":505,"width":505};